import "./index.scss";
import ImageIcon from "components/ImageIcon";
import React from "react";

import recursiveRender from "utilities/recursiveRender";

// TODO: TS props
interface EventBookingCtaProps {
  labelBookEvent: any;
  linkBookEvent: any;
}

export default function EventBookingCta({
  labelBookEvent,
  linkBookEvent,
}: EventBookingCtaProps) {
  return (
    <div className="EventBookingCta row d-flex justify-content-center">
      <div className="col-12 col-md-auto flex-grow-1">
        <div className="EventBookingCta__label">
          <ImageIcon
            iconType="svgDesign"
            svgLibrary="general_medium_time"
            svgColor="brandPrimary"
            svgBackground="neutralQuaternary"
          />
          <h5 className="EventBookingCta__label__text">
            {labelBookEvent?.text?.text}
          </h5>
        </div>
      </div>
      <div className="EventBookingCta__cta col-12 col-md-auto">
        {recursiveRender({ cfComponent: linkBookEvent })}
      </div>
    </div>
  );
}
